module.exports = __webpack_public_path__ + "static/banner-3star-32c55b94c9919c3010fa8465c725ae53.png";